import axios from 'axios'

export default {
  async fetchMixes({ commit }) {
    const { data } = await axios.get('/minds')

    commit('updatePlants', data.plants)
    commit('updateAsphaltMixes', data.asphaltMixes)
  },
  async fetchPlants({ commit }) {
    const { data } = await axios.get('/minds/plants')

    commit('updatePlants', data.plants)
  },
  async fetchMindsData({ commit, getters }, { asphaltMixId }) {
    const { data } = await axios.get(`/minds/${asphaltMixId}`)

    commit('updateTemperatureReadings', data.temperatureReadings)
    commit('updateHotBinReadings', data.hotBinReadings)
    commit('updateColdBinReadings', data.coldBinReadings)
    commit('updateLabResults', data.productionLabResults)
  },
}
